import { useLocation, useParams } from 'react-router-dom';
import { useInvoiceDetailsQuery } from 'src/pages/billing/billingApi';
import { useSingleStudentDetailsQuery } from 'src/pages/single-student/singleStudentApi';

export const useActivityStudent = () => {
  const { id } = useParams();
  const location = useLocation();
  const isStudentProfile = location.pathname.includes('student');
  const { data: invoiceData } = useInvoiceDetailsQuery(id || '', {
    skip: !id || isStudentProfile,
  });
  const studentId = isStudentProfile ? id || '' : invoiceData?.studentId || '';
  const { data: student } = useSingleStudentDetailsQuery(studentId, {
    skip: !studentId,
  });

  return { student, studentId };
};
